import PropTypes from 'prop-types';

export const TActivityType = {
  idtypeactivity: PropTypes.string,
  typeactivity: PropTypes.string,
};
